import React, { useState } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import toast from "react-hot-toast";
import EmailConfigService from "../../services/KangarooServices/EmailConfigService";

const TestEmail = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendTestEmail = async () => {
    if (!email) {
      toast.error("Please enter an email address");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        to: email,
        subject: "Test Email from System",
        body: `
          Hello,
          This is a test email to verify that the email service is working correctly.
          If you received this email, your configuration is successful.
          Regards,
          System Admin
        `,
      };

      const response = await EmailConfigService.testMail(payload);

      toast.success(response || "Test email sent successfully!");
      setEmail("");
    } catch (error) {
      console.error("Email test error:", error);
      toast.error(
        error?.response?.data?.message || "Failed to send test email",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Test Email" pageTitle="User Management" />

        <Row className="justify-content-center">
          <Col md={6}>
            <Card>
              <CardBody>
                <h5 className="mb-3">Email Testing Tool</h5>

                <p className="text-muted">
                  Use this tool to verify whether the email service is working
                  properly. Enter an email address and click "Send Test Email".
                </p>

                <Form>
                  <FormGroup>
                    <Label for="email">Recipient Email</Label>
                    <Input
                      type="email"
                      id="email"
                      placeholder="Enter email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FormGroup>

                  <Button
                    color="primary"
                    onClick={handleSendTestEmail}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Sending...
                      </>
                    ) : (
                      "Send Test Email"
                    )}
                  </Button>
                </Form>

                <div className="mt-4">
                  <h6>What this does:</h6>
                  <ul className="text-muted">
                    <li>Checks if the email API is reachable</li>
                    <li>Verifies SMTP/email configuration</li>
                    <li>Confirms email delivery capability</li>
                  </ul>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default TestEmail;
